(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('floating-contact')) {
    customElements.define('floating-contact', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        document.addEventListener('click', (event) => {
          if (this.details.open && !this.contains(event.target)) this.details.open = false;
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.details.open) {
            this.details.open = false;
            this.summary.focus();
          }
        });
        this.querySelectorAll('[data-contact-action]').forEach((link) => {
          link.addEventListener('click', () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: `${link.dataset.contactAction}_click` });
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-tabs"] && !Shopify.designMode) return;
  try {
    
  class ProductDetailsTabs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.normalizeDescriptionImages();
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activateTab(index));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
      });
    }

    normalizeDescriptionImages() {
      const panel = this.querySelector('.product-details-tabs__panel--description');
      if (!panel) return;

      const isFullWidth = this.classList.contains('product-details-tabs--images-full');
      const isContentWidth = this.classList.contains('product-details-tabs--images-content');
      if (!isFullWidth && !isContentWidth) return;

      panel.querySelectorAll('img').forEach((image) => {
        image.removeAttribute('width');
        image.removeAttribute('height');
        image.style.setProperty('display', 'block', 'important');
        image.style.setProperty('float', 'none', 'important');
        image.style.setProperty('height', 'auto', 'important');
        image.style.setProperty('object-fit', 'contain', 'important');

        if (isFullWidth) {
          image.style.setProperty(
            'width',
            'calc(100% + var(--tabs-panel-padding) + var(--tabs-panel-padding))',
            'important'
          );
          image.style.setProperty('max-width', 'none', 'important');
          image.style.setProperty('margin-left', 'calc(0px - var(--tabs-panel-padding))', 'important');
          image.style.setProperty('margin-right', 'calc(0px - var(--tabs-panel-padding))', 'important');
        } else {
          image.style.setProperty('width', '100%', 'important');
          image.style.setProperty('max-width', '100%', 'important');
          image.style.setProperty('margin-left', '0', 'important');
          image.style.setProperty('margin-right', '0', 'important');
        }

        let wrapper = image.parentElement;

        while (wrapper && wrapper !== panel) {
          wrapper.classList.add('product-details-tabs__image-wrap');
          wrapper.style.setProperty('display', 'block', 'important');
          wrapper.style.setProperty('float', 'none', 'important');
          wrapper.style.setProperty('box-sizing', 'border-box', 'important');
          wrapper.style.setProperty('width', '100%', 'important');
          wrapper.style.setProperty('max-width', 'none', 'important');
          wrapper.style.setProperty('margin-left', '0', 'important');
          wrapper.style.setProperty('margin-right', '0', 'important');
          wrapper.style.setProperty('padding-left', '0', 'important');
          wrapper.style.setProperty('padding-right', '0', 'important');
          wrapper = wrapper.parentElement;
        }
      });
    }

    activateTab(index, moveFocus = false) {
      const update = () => {
        this.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel, panelIndex) => {
          panel.hidden = panelIndex !== index;
        });

        if (moveFocus) this.tabs[index].focus();
      };

      if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        document.startViewTransition(update);
      } else {
        update();
      }
    }

    handleKeydown(event, index) {
      let nextIndex = index;

      if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === index) return;

      event.preventDefault();
      this.activateTab(nextIndex, true);
    }
  }

  if (!customElements.get('product-details-tabs')) {
    customElements.define('product-details-tabs', ProductDetailsTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
